module.exports = __webpack_public_path__ + "static/3-IMG-5777-195e556fc62a028de1ea97d6359d4504.jpg";